import {
  Flex,
  Input,
  Typography,
  IconErrorFilled,
  ColorValues,
} from '@banhala/ui-kit';
import type { KeyboardTypeOptions } from 'react-native';
import { isNotNil } from 'shared/src/utils';

type AddressTextFieldProps = {
  value: string;
  placeholder: string;
  onChangeText?: (text: string) => void;
  /** 읽기전용 필드(우편번호/주소) — 탭하면 우편번호 검색 진입 */
  onPress?: () => void;
  /** 에러 메시지 (있으면 에러 상태) */
  errorMessage?: string;
  keyboardType?: KeyboardTypeOptions;
  /**
   * QA 자동화 식별자(ENABLE-1174).
   * 읽기전용(우편번호/주소)은 탭 대상인 Flex.Row에, 편집형은 입력 대상인 Input에 부여.
   */
  testID?: string;
};

/**
 * iOS `ErrorableTextField` 재현.
 * - underline(gray20, 에러 시 pink40) + 에러 시 우측 IconErrorFilled + 하단 에러 라벨
 */
export const AddressTextField = ({
  value,
  placeholder,
  onChangeText,
  onPress,
  errorMessage,
  keyboardType,
  testID,
}: AddressTextFieldProps) => {
  const isError = isNotNil(errorMessage) && errorMessage.length > 0;
  const isReadOnly = isNotNil(onPress);

  return (
    <Flex>
      <Flex.Row
        testID={isReadOnly ? testID : undefined}
        alignItems="center"
        borderBottomWidth={1}
        borderColor={isError ? 'pink40' : 'gray20'}
        padding={{ top: 14, bottom: 13, left: 12, right: isError ? 4 : 12 }}
        onPress={onPress}
      >
        <Input
          testID={isReadOnly ? undefined : testID}
          style={{ flex: 1, margin: 0, padding: 0 }}
          fontVariant="body1"
          value={value}
          placeholder={placeholder}
          placeholderTextColor={ColorValues.gray50}
          onChangeText={onChangeText}
          editable={!isReadOnly}
          keyboardType={keyboardType}
        />
        {isError && (
          <IconErrorFilled width={24} height={24} fill={ColorValues.pink40} />
        )}
      </Flex.Row>
      {isError && (
        <Flex padding={{ horizontal: 8 }} margin={{ top: 10 }}>
          <Typography type="body2" color="content_negative">
            {errorMessage}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};
